export default __webpack_public_path__ + "static/media/wc2022-logo.f3750c13.png";